/**
 * The page shown on a successful outcome
 */
import * as React from 'react';
import * as gls from '../ap/layout/gls';
import * as styles from '../ap/base/styles';
import { Heading3, Heading4, Paragraph } from '../ap/base/text';
import { Anchor, AnchorStyles } from '../ap/base/anchor';
import { Done } from '../ap/base/icons';
import { Page } from './base/page';
import { DialogIsland, DialogHeadingReef, MaxWidthIsland } from '../ap/pages/sections';
import { Hr } from '../ap/base/hr';
import { SectionLoader } from '../ap/base/loader';
import { ActionAnchor } from '../ap/base/anchor';
import { FieldState, FormState } from '../ap/fields/field';
import { i18n } from '../config/i18n';
import { TextInputField } from '../ap/fields/inputField';
import { PrimaryButton, SecondaryButton, TertiaryButton } from '../ap/base/button';
import { route, navigateTo, navigateToError } from '../links';
import { Alert, AlertType } from '../ap/base/alerts';
import { checkPin, sendPin } from '../webServices/smsService';
import { Loader } from '../ap/base/loader';
import { Form } from '../ap/base/form';
import { SubmitInputPrimary as SubmitInput } from '../ap/base/input';
import * as formatters from '../utils/formatters';
import { DocumentSightingStepper, DocumentSightingStep } from './components/appStepper';
import { appState } from '../state/state';
const {voi} = appState;
import {observer} from 'mobx-react';
import { trackRegisterVerifyPage, trackLinkClick } from '../ap/omniture/omnitureService';


/**
 * The layout for the table
 */
const labelFontSize = '20px';
const textColor = styles.colors.warmGrey4;
const SimpleNameValue = ({ name, value }: { name: string, value: string }) => {
  return <div style={{color: textColor, fontSize: labelFontSize}}>
    <div style={{width: '200px', display: 'inline-block'}}>{ name }</div>
    <div style={{display: 'inline-block'}}>{ value }</div>
  </div>;
}

interface RegisterVerifyPageProps {
}
interface RegisterVerifyPageState {
  invalidMessage?: string
  sending?: boolean
  checking?: boolean
}
export class RegisterVerifyPage extends React.Component<RegisterVerifyPageProps, RegisterVerifyPageState> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  resend = () => {
    const phone = formatters.cleanupPhoneNumbers(voi.phoneNumber.value);
    this.setState({ sending: true });
    trackLinkClick('diy:register','mobile verification:resend');
    sendPin({ phone })
      .then(() => {
        setTimeout(() => this.setState({ sending: false }), 1000);
      })
      /** e.g Too many SMSes */
      .catch(() => {
        this.setState({ checking: false });
        this.setState({ invalidMessage: `Sending code failed. Please check the entered phone number.` });
      });
  }

  formState = new FormState(() => [voi.pinCode]);

  verifyPin = () => {
    this.setState({ checking: true });
    this.formState.validate();
      const hasError = this.formState.hasError;
      if (hasError) {
        this.setState({ checking: false });
        return;
      };

      const phone = formatters.cleanupPhoneNumbers(voi.phoneNumber.value);
      const code = voi.pinCode.value;
      checkPin({ phone, code }).then(res => {  //handle the error 500
        if (!res.status || res.status !== "OK") {
          this.setState({ checking: false });
          this.setState({ invalidMessage: `Invalid Pin Code: ${code}` });
          return;
        }

        voi.verifiedPhoneNumber.setValue(phone);
        navigateTo(route.documentSighting(), true);
      })
      .catch(() => {
        this.setState({ checking: false });
        this.setState({ invalidMessage: `Invalid Pin Code: ${code}` });
        return;
      });
    // ...existing code...
  }

  componentDidMount() {
    trackRegisterVerifyPage();
  }

  render() {
    const omnitureOnClickVerify = () => trackLinkClick('diy:register','mobile verification:verify');

    const stepper =
      <MaxWidthIsland>
        <DocumentSightingStepper current={DocumentSightingStep.MobileVerification} />
      </MaxWidthIsland>

    const header = <DialogHeadingReef>
      <Heading3 text="Mobile Verification" />
    </DialogHeadingReef>;

    const body =
      <DialogIsland>
        <Form onSubmit={this.verifyPin}>
          <gls.ContentVerticalContentMargined margin={styles.spacing.verticalBetweenFields}>
            {
              this.state.invalidMessage
              && <Alert type={AlertType.Error}>
                {this.state.invalidMessage}
              </Alert>
            }
            <div>
              <Paragraph>
                <span>We have sent an SMS to {voi.phoneNumber.value}. <br />
                Please enter the six digit code below</span>
            </Paragraph>
            </div>
            <div>
              <TextInputField id="pinCode" name="pinCode" label={i18n("pinCode")} star={true} fieldState={voi.pinCode} onChange={() => this.setState({ invalidMessage: null })} autoFocus={true} />
            </div>
            <gls.ContentHorizontal>
              <gls.Flex />
              <TertiaryButton id="backButton" text="Back" onClick={() => navigateTo(route.registerEdit(), false, 'diy:register', 'mobile verification:back')} />
              <gls.SmallHorizontalSpace space={30} />
              {
                <SubmitInput id="verifyButton" value="Verify" disabled={this.formState.hasError} loading={!!this.state.checking} onClick={omnitureOnClickVerify}/>
              }
            </gls.ContentHorizontal>
            <gls.ContentHorizontal>
              <gls.Flex />
              {
                this.state.sending
                  ? <Loader />
                  : <Paragraph><span>Didn't receive the SMS? <button className={AnchorStyles.rootClassName} onClick={this.resend}>Resend</button></span></Paragraph>
              }
            </gls.ContentHorizontal>
          </gls.ContentVerticalContentMargined>
        </Form>
      </DialogIsland>;

    return (
      <Page
        loggedIn={true}
        sections={[stepper, header, body]}
        />
    );
  }
}

export default observer(RegisterVerifyPage);
